import React, {useEffect, useState} from 'react';
import {Section} from '../../components/Section';
import {Table} from '../../components/Table';
import {UserMileageHistoryResponse} from "../../types/types";
import moment from "moment";
import {getMileages} from "../../apis/user";
import {FrontPagination} from "../../components/FrontPagination";
import {mileageTypeText} from "../../utils/texts";

const data = {
    items: [
        {
            id: 1,
            createdAt: new Date(),
            description: '구매 적립',
            Amount: 1000,
        },
        {
            id: 2,
            createdAt: new Date(),
            description: '구매시 사용',
            Amount: -1000,
        },
        {
            id: 3,
            createdAt: new Date(),
            description: '구매 적립',
            Amount: 1000,
        },
        {
            id: 4,
            createdAt: new Date(),
            description: '구매 적립',
            Amount: 1000,
        },
    ],
    total: 4,
};

export const MyPointTable = () => {
    const [points, setPoints] = useState<UserMileageHistoryResponse[]>([])
    const [page, setPage] = useState<number>(0);
    const [total, setTotal] = useState<number>(0);

    useEffect(() => {
        getMileages(page, 10).then(r => {
            setPoints(r.data.payload.content);
            setTotal(r.data.payload.totalPages);
        }).catch(e => console.log(e))
    }, [page])

    return (
        points.length === 0 ?
            <>
                <div className={'py-20 center text-center'}>
                    <p>적립금 적립 내역이 없습니다.</p>
                </div>
            </>
            :
            <>
                {/* Mobile */}
                <Section className="md:hidden space-y-4 border-t pt-4 text-12">
                    {points.map((point, index) => (
                        <div className="flex space-x-12 border-b pb-4" key={index}>
                            <div className=" space-y-2">
                                {[
                                    {title: 'No.'},
                                    {title: '일시'},
                                    {title: '내용'},
                                    {title: '지급 / 사용'},
                                ].map((item, index) => (
                                    <div key={index} className="text-gray-600">{item.title}</div>
                                ))}
                            </div>

                            <div className="space-y-2">
                                <p className="">{point.userMileageHistoryId}</p>
                                <p className="">
                                    {moment(point.createdAt).format('YYYY.MM.DD HH:mm')}
                                </p>
                                <p className="">{mileageTypeText(point.type)}</p>
                                <p
                                    className={`${
                                        point.mileageAmount > 0
                                            ? 'text-blue-500'
                                            : point.mileageAmount < 0
                                                ? 'text-red-500'
                                                : ''
                                    }`}
                                >
                                    {' '}
                                    {point.mileageAmount > 0 && '+'}
                                    {point.mileageAmount.toLocaleString()}
                                </p>
                            </div>
                        </div>
                    ))}
                </Section>

                {/* Desktop */}
                <Table className="hidden md:table mt-5">
                    <Table.Head>
                        <Table.Row>
                            <Table.Th>No.</Table.Th>
                            <Table.Th>일시</Table.Th>
                            <Table.Th>내용</Table.Th>
                            <Table.Th>지급 / 사용</Table.Th>
                        </Table.Row>
                    </Table.Head>
                    <Table.Body>
                        {points.map((point, index) => (
                            <Table.Row key={index}>
                                <Table.Td>{point.userMileageHistoryId}</Table.Td>
                                <Table.Td>
                                    {moment(point.createdAt).format(`YYYY.MM.DD HH:mm`)}
                                </Table.Td>
                                <Table.Td>{mileageTypeText(point.type)}</Table.Td>
                                <Table.Td
                                    className={`${
                                        point.mileageAmount > 0
                                            ? 'text-blue-500'
                                            : point.mileageAmount < 0
                                                ? 'text-red-500'
                                                : ''
                                    }`}
                                >
                                    {point.mileageAmount > 0 && '+'}
                                    {point.mileageAmount.toLocaleString()}
                                </Table.Td>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>

                <FrontPagination
                    page={page}
                    totalPages={total}
                    onPrevious={() => page !== 0 && setPage(page - 1)}
                    onNext={() => page !== 10 && setPage(page + 1)}
                    onNumClick={num => setPage(num - 1)}
                />
            </>
    );
};
